module.exports = __webpack_public_path__ + "img/food.b2324718.svg";